import React from "react";

const Contact = () => {
  const map =
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.2785740955013!2d74.93146857481172!3d12.806933887516972!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba35f3cc4820f2b%3A0x51c3784fba6f8180!2sP.A.%20College%20of%20Engineering%20(PACE)!5e0!3m2!1sen!2sin!4v1706537935243!5m2!1sen!2sin";

  return (
    <>
      <section className="contact-page">
        <div className="contact-container">
          {/* Header */}
          <div className="contact-header">
            <h1>CONTACT PA POLYTECHNIC</h1>
            <div className="header-line"></div>
          </div>

          {/* Main Content */}
          <div className="contact-card">
            {/* Address Section Header */}
            <div className="address-header">
              <h2>Address</h2>
            </div>

            <div className="address-content">
              {/* College Name and Address */}
              <div className="college-info">
                <h3>P.A. Polytechnic (PAPT),</h3>
                <p className="address-text">
                  Mangalore, Near Mangalore University,<br />
                  Kudla Konaje Proper,<br />
                  Karnataka - 574153,<br />
                  INDIA.
                </p>
              </div>

              {/* Contact Details */}
              <div className="contact-details">
                <div className="contact-item">
                  <span className="contact-label">Reception / Office:</span>
                  <span className="contact-value">0824-2284710</span>
                </div>

                <div className="contact-item">
                  <span className="contact-label">Phone:</span>
                  <span className="contact-value">+91 9964668925</span>
                </div>

                <div className="contact-item">
                  <span className="contact-label">For Admission</span>
                  <span className="contact-value">+91 9980022000</span>
                </div>

                <div className="contact-item">
                  <span className="contact-label">Email:</span>
                  <span className="contact-value">principal@papt.edu.in</span>
                </div>
              </div>
            </div>
          </div>

          {/* Email IDs Section */}
          <div className="email-ids-card">
            <div className="email-ids-header">
              <h2>Email ID's</h2>
            </div>
            <div className="email-ids-content">
              <div className="email-contact">
                <span className="email-name">Managing Trustee:</span>
                <span className="email-value">abdulla@pace.edu.in</span>
              </div>
              
              <div className="email-contact">
                <span className="email-name">Principal:</span>
                <span className="email-value">principal@papt.edu.in</span>
              </div>
              
              
              
              <div className="email-contact">
                <span className="email-name">Careers & Employment:</span>
                <span className="email-value">hr@pace.edu.in</span>
              </div>
              
              
              
              
              
              
              
              <div className="email-contact">
                <span className="email-name">Public Relations:</span>
                <span className="email-value">pr@pace.edu.in</span>
              </div>
              
              
              
              <div className="email-contact">
                <span className="email-name">Human Resources Department:</span>
                <span className="email-value">hr@pace.edu.in</span>
              </div>
            </div>
          </div>

          {/* Other Contacts Section */}
          <div className="other-contacts-card">
            <div className="other-contacts-header">
              <h2>Other Contacts</h2>
            </div>
            <div className="other-contacts-content">
              <div className="contact-institute">
                <span className="institute-name">P. A. First Grade College:</span>
                <span className="institute-email">principal@pafgc.in</span>
              </div>
              
              <div className="contact-institute">
                <span className="institute-name">P. A. College of Pharmacy:</span>
                <span className="institute-email">principal.pacp@pace.edu.in</span>
              </div>
              
              <div className="contact-institute">
                <span className="institute-name">P.A. Institute of Physiotherapy:</span>
                <span className="institute-email">principalpaip@pace.edu.in</span>
              </div>
              
              <div className="contact-institute">
                <span className="institute-name">P.A. Engineering</span>
                <span className="institute-email">principal@pace.edu.in</span>
              </div>
            </div>
          </div>

          {/* Map Section */}
          <div className="map-card">
            <div className="map-header">
              <h2>Location</h2>
            </div>
            <div className="map-wrapper">
              <iframe
                src={map}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .contact-page {
          min-height: 100vh;
          background-color: #f9fafb;
          padding: 3rem 1rem;
        }

        .contact-container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .contact-header {
          margin-bottom: 2rem;
        }

        .contact-header h1 {
          font-size: 2.5rem;
          font-weight: bold;
          text-align: center;
          color: #00b5e2;
          margin-bottom: 0.5rem;
        }

        .header-line {
          height: 4px;
          background-color:#c3c000;
          width: 100%;
        }

        .contact-card {
          background: white;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
          border-radius: 0.5rem;
          overflow: hidden;
          margin-bottom: 2rem;
        }

        .address-header {
          background: linear-gradient(to right, #a8b526, #c4d12e);
          padding: 1.5rem 2rem;
        }

        .address-header h2 {
          font-size: 1.5rem;
          font-weight: bold;
          color: white;
          margin: 0;
        }

        .address-content {
          padding: 3rem 2rem;
        }

        .college-info {
          margin-bottom: 2rem;
        }

        .college-info h3 {
          font-size: 1.5rem;
          font-weight: bold;
          color: #1f2937;
          margin-bottom: 1rem;
        }

        .address-text {
          font-size: 1.125rem;
          color: #374151;
          line-height: 1.8;
          margin: 0;
        }

        .contact-details {
          padding-top: 1.5rem;
          border-top: 1px solid #e5e7eb;
        }

        .contact-item {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          margin-bottom: 1rem;
          font-size: 1rem;
          color: #374151;
        }

        .contact-label {
          font-weight: 600;
        }

        .contact-value {
          color: #4b5563;
        }

        .email-ids-card {
          background: white;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
          border-radius: 0.5rem;
          overflow: hidden;
          margin-bottom: 2rem;
        }

        .email-ids-header {
          background: linear-gradient(to right, #a8b526, #c4d12e);
          padding: 1.5rem 2rem;
        }

        .email-ids-header h2 {
          font-size: 1.5rem;
          font-weight: bold;
          color: white;
          margin: 0;
        }

        .email-ids-content {
          padding: 2.5rem 2rem;
          background-color: #ffffff;
        }

        .email-contact {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          padding: 1.25rem 0;
        }

        .email-contact:not(:last-child) {
          margin-bottom: 0.5rem;
        }

        .email-name {
          font-weight: 600;
          color: #1f2937;
          font-size: 1rem;
        }

        .email-value {
          color: #4b5563;
          font-size: 1rem;
        }

        .other-contacts-card {
          background: white;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
          border-radius: 0.5rem;
          overflow: hidden;
          margin-bottom: 2rem;
        }

        .other-contacts-header {
          background: linear-gradient(to right, #a8b526, #c4d12e);
          padding: 1.5rem 2rem;
        }

        .other-contacts-header h2 {
          font-size: 1.5rem;
          font-weight: bold;
          color: white;
          margin: 0;
        }

        .other-contacts-content {
          padding: 2.5rem 2rem;
          background-color: #ffffff;
        }

        .contact-institute {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          padding: 1.25rem 0;
        }

        .contact-institute:not(:last-child) {
          margin-bottom: 0.5rem;
        }

        .institute-name {
          font-weight: 600;
          color: #1f2937;
          font-size: 1rem;
        }

        .institute-email {
          color: #4b5563;
          font-size: 1rem;
        }

        .map-card {
          background: white;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
          border-radius: 0.5rem;
          overflow: hidden;
        }

        .map-header {
          background: linear-gradient(to right, #a8b526, #c4d12e);
          padding: 1.5rem 2rem;
        }

        .map-header h2 {
          font-size: 1.5rem;
          font-weight: bold;
          color: white;
          margin: 0;
        }

        .map-wrapper {
          height: 400px;
        }

        .map-wrapper iframe {
          width: 100%;
          height: 100%;
          border: none;
        }

        @media (max-width: 768px) {
          .contact-header h1 {
            font-size: 1.875rem;
          }

          .address-content {
            padding: 2rem 1.5rem;
          }

          .college-info h3 {
            font-size: 1.25rem;
          }

          .address-text {
            font-size: 1rem;
          }
        }
      `}</style>
    </>
  );
};

export default Contact;